module.exports = __webpack_public_path__ + "static/20200804_154637-71c95c50f747e85d2a151fa2bace63d0.jpg";